import React from 'react'

import { DatasetExp } from './DatasetExp'

export class App extends React.Component {
  render() {
    return <DatasetExp />
  }
}
